import { evaluationPercentage, percentageDelta } from './evaluationIntegrity';

// #Fase1-10 — Una versión sin calificación interrumpe la tendencia, no equivale a cero.
export function buildSummary(evaluations) {
  const published = evaluations
    .filter((e) => e.status === 'publicada')
    .sort((a, b) => b.version - a.version);
  const inProgress = evaluations.filter((e) =>
    ['borrador', 'en_revision', 'regresada'].includes(e.status)
  );
  const blocked = evaluations.filter((e) => e.is_blocked);
  const latest = published[0] || null;
  const prev = published[1] || null;
  const improvementRate = percentageDelta(evaluationPercentage(latest), evaluationPercentage(prev));
  const scoreHistory = published
    .slice()
    .reverse()
    .map((e) => ({
      version: `v${e.version}`,
      Puntaje: evaluationPercentage(e),
      instalacion: e.general_fields?.instalacion,
    }));
  return {
    total: evaluations.length,
    publishedCount: published.length,
    inProgressCount: inProgress.length,
    blockedCount: blocked.length,
    latestScore: latest?.score || 0,
    latestPercentage: evaluationPercentage(latest),
    latestSemaforo: latest?.semaforo || null,
    improvementRate,
    scoreHistory,
    latestEval: latest,
    activeEval: inProgress[0] || null,
  };
}
